// 首頁「近況」的小工具（2026-10-04 首頁進化）。資料仍住 i18n about.nowItems（首頁與 About 共用，scripts/test-now-items.mjs 把關）；
// 這裡只做兩件事：把日期字串讀成起訖，算「進行中／即將／已結束」；把連結路徑對回 work-catalog 的 slug，拿那件作品的封面。
// 狀態只在瀏覽器裡算（預渲染的 HTML 不放，免得建置那天的狀態被凍在靜態頁上）。

const pad = n => String(n).padStart(2, '0')
const lastDay = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate()

// '2026.10.22–24'、'2026.08–10'、'2026.09.24–10.11'、'2026.10.22'、'2026.10.22–2027.01.05' → { start, end }（YYYY-MM-DD）；讀不懂回 null
export function parseRange (text) {
  const [left, right] = String(text || '').trim().split(/\s*[–—-]\s*/)
  const a = left.split('.').map(Number)
  if (a.length < 2 || a.some(n => !Number.isFinite(n))) return null
  const [y, m, d] = a
  const start = `${y}-${pad(m)}-${pad(d || 1)}`
  if (!right) return { start, end: d ? start : `${y}-${pad(m)}-${pad(lastDay(y, m))}` }
  const b = right.split('.').map(Number)
  if (b.some(n => !Number.isFinite(n))) return null
  let end
  if (d) {
    if (b.length === 1) end = `${y}-${pad(m)}-${pad(b[0])}`
    else if (b.length === 2) end = `${y}-${pad(b[0])}-${pad(b[1])}`
    else end = `${b[0]}-${pad(b[1])}-${pad(b[2])}`
  } else if (b.length === 1) end = `${y}-${pad(b[0])}-${pad(lastDay(y, b[0]))}`
  else end = `${b[0]}-${pad(b[1])}-${pad(lastDay(b[0], b[1]))}`
  return end < start ? null : { start, end }
}

// today：'YYYY-MM-DD'（台北日期）。回 'on'｜'soon'｜'past'｜null
export function nowStatus (text, today) {
  const r = parseRange(text)
  if (!r || !today) return null
  if (today < r.start) return 'soon'
  if (today > r.end) return 'past'
  return 'on'
}

export const taipeiToday = (date = new Date()) => new Date(date.getTime() + 8 * 3600e3).toISOString().slice(0, 10)

// '/work/reality-lens/' → 'reality-lens'；'/exhibition/the-last-input/' → 'the-last-input'
export function slugFromPath (to) {
  const m = /^\/(?:work|exhibition)\/([^/?#]+)\/?$/.exec(String(to || ''))
  return m ? m[1] : null
}

// 主視覺跟近況連動：第一個「還沒結束」且 to 指到有封面作品的項目；帶 hero: true 的優先；全部過期回 fallback（home-featured 第一件）。
// hasCover(slug) 由呼叫端給（catalog 查得到封面）。回 { slug, item }，item 是 null 代表用的是 fallback。
export function pickHero (items, today, hasCover, fallback) {
  const open = (items || []).filter(it => {
    const slug = slugFromPath(it.to)
    return slug && hasCover(slug) && parseRange(it.date) && nowStatus(it.date, today) !== 'past'
  })
  const it = open.find(i => i.hero) || open[0]
  return it ? { slug: slugFromPath(it.to), item: it } : { slug: fallback, item: null }
}
